// Hook returns true if consent landing page should be shown
// Logic extracted here so we can reuse in page-layout component to hide feedback form icon

import { useUserInfo } from "@/common/hooks";
import { useFastshiftSelector } from "@/state";

export const useShouldShowConsentLandingPage = (): boolean => {
    const { data: user, error: userError } = useUserInfo();
    const isPartnerOrInternal =
        user?.userType === "PARTNER" || user?.userType === "INTERNAL";

    const { data: userHasConsented, error: userConsentError } =
        useFastshiftSelector((state) => state.portalUserConsent);

    const portalHasCriticalError = userError || userConsentError;

    const shouldShowConsentLandingPage =
        !isPartnerOrInternal &&
        userHasConsented === false && // we don't want this to evaluate true when null
        !portalHasCriticalError;

    return shouldShowConsentLandingPage;
};
